<!--
    描述：组织架构/用户
    日期：2021/04/22
    作者：zwh
-->
<template>
    <div class="h100 org-user-main">
        <w-split class="h100" v-model="splitValue">
            <div class="w-page-main left" slot="left" style="padding-top:0px">
                <div class="w-page-container">
                    <deptImportTree ref="deptImportTree"
                                   @row-click="deptRowClick" @org-trans-data="orgTransData"></deptImportTree>
                </div>
            </div>
            <div class="w-page-main right" slot="right" style="padding-top:0px">
                <div class="w-page-container">
                    <deptImportUserTable ref="deptImportUserTable" @user-trans-data="userTransData"></deptImportUserTable>
                </div>
            </div>
        </w-split>
    </div>
</template>
<script>
import wSplit from '@/components/split/split'
import deptImportTree from './dept_import_tree'
import deptImportUserTable from './dept_import_user_table'
import { saveDeptsAndUsers } from 'api/system/sysDept.js'
export default {
    name : '',
    components: {
        wSplit,deptImportTree,deptImportUserTable,
    },
    data() {
        return {
            splitValue: 0.35,

            data : [],
        }
    },
    mounted() {},
    computed: {},
    watch: {},
    created() {

    },
    methods: {
        deptRowClick(row) {
            this.$refs.deptImportUserTable.getTableList(row)
        },
        doSave(){
            saveDeptsAndUsers(this.data).then(res=>{
                if(res.operationCode == 1) {
                    this.$message({'message':'导入成功', type:'success'})
                    this.$emit('handle-success')
                }
            })
        },
        orgTransData(data){
            this.data = data
        },
        userTransData(deptId, userRow){
            let data0Tree = this.data.concat()
            let data0Array = this.$utils.toTreeArray(data0Tree)
            let treeNode = data0Array.find(e=> e.id == deptId)
            let user = treeNode.users.find(e=> e.id == userRow.id)
            user.isChecked = userRow.isChecked

            this.data = this.$utils.toArrayTree(data0Array)
        },
    }
}
</script>
<style lang="less">
.org-user-main {
    height : 500px;
}
</style>